module.exports = __webpack_public_path__ + "assets/scaffold-erector.svg?4ad285d5b884040fd2b2c0a55c6e909d";